import { Component, TemplateRef, ViewChild, inject } from '@angular/core';
//SUB COMPONENTS
import { HeaderComponent } from '@components/dashboard/header/header.component';
import { NavComponent } from '@components/dashboard/navigation/nav.component';
import { CommonModule } from '@angular/common';
import { DashboardService } from '@services/dashboard.service';
import { NewsItem, LocationData, City, Province } from '@interfaces/models.interface';
import { ServerResponse } from '@interfaces/general.interface';
import { LocalService } from '@services/local.service';
import { FormsModule } from '@angular/forms'; // Import FormsModule here
import { NgbModal,NgbAlertModule, NgbTimepickerModule } from '@ng-bootstrap/ng-bootstrap';
import {Router, RouterModule} from '@angular/router';
import { MomentModule } from 'ngx-moment';
import { Apollo } from 'apollo-angular';
import { NEWS_LIST } from '@gql_queries/news/mutations';
import { CREATE_NEWS_MUTATION, UPDATE_NEWS_MUTATION } from '@gql_queries/news/queries';
import { AuthStore } from '@store/auth.store';
import { QuillModule } from 'ngx-quill';
import { DownloadHandlerUtil } from '@shared/utils/download-handler-util';

  @Component({
      selector: 'app-dashboard-news-events',
      standalone: true,
      templateUrl: './dashboard-news-events.component.html',
      styleUrl: './dashboard-news-events.component.css',
      imports: [NgbAlertModule, HeaderComponent, NavComponent, CommonModule, FormsModule, RouterModule, MomentModule, QuillModule],
  })

  export class DashboardNewsEventsComponent {
    constructor(
      private router: Router,
      private dasher: DashboardService,
      private localservice: LocalService,
      private apollo: Apollo,
      private authStore: AuthStore,
      private downloadHandler: DownloadHandlerUtil
  ) { }

  imageSrc?: string | ArrayBuffer | null;

  quillModules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      ['blockquote', 'code-block'],
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      [{ 'indent': '-1' }, { 'indent': '+1' }],
      [{ 'direction': 'rtl' }],
      [{ 'size': ['small', false, 'large', 'huge'] }],
      [{ 'font': [] }],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'script': 'sub' }, { 'script': 'super' }],
      [{ 'align': [] }],
      ['link'],
      ['clean']
    ]
  };

  private modalService = inject(NgbModal);
  @ViewChild('successModal') successModalRef!: TemplateRef<any>;
  public successMessage: string = '';
  // locationData: LocationData = {
  //     provinces: [],
  //     cities: [],
  // };

  // selectedProvinceCode: string = '';
  // filteredCities: City[] = [];
  // selectedProvince: Province = {
  //     id: 0,
  //     provCode: '',
  //     provDesc: '',
  //     psgcCode: '',
  //     regCode: '',
  // };
  // selectedCity: City = {
  //     citymunCode: '',
  //     citymunDesc: '',
  //     id: 0,
  //     provCode: '',
  //     psgcCode: '',
  //     regDesc: '',
  // };

  public NEList: NewsItem[] = [];

  public searchKeyword: string = '';
  public currentSelectedPageList: NewsItem[] = [];
  public maxPages: number = 0;
  public disableActionBtns: any = {
      next: false,
      prev: false,
  };
  public NEPages: number[] = [];
  public currentPage: number = 1;
  public pageSize: number = 15;

  public detailViewed: Record<string, any> = {};
  public showDetails: boolean = false;
  public NEFormNew: Record<string, any> = {
    title: '',
    subTitle: '',
    type: '',
    description: '',
    photo: '',
    link: '',
    audience: '',
    status: '',
  }
  public newPublishToggle: boolean = false;
  NEPhoto: File | null = null;

  public enableEdit: boolean = false;
  public pendingPublishStatus: string = 'published';

  ngOnInit(): void {
    this.fetchNews('all')
    // this.populateLocationDropdowns();
  }

  downloadNewsEventsReport(): void {
    this.downloadHandler.downloadReport('news_events', {
      data: this.currentSelectedPageList,
      fileName: 'news-events-report',
    });
  }

  fetchNews(action: string = ''){
    var fromPage = 1;

    if(action != ''){
        fromPage = this.currentPage;
        switch(action){
            case 'next':
                this.currentPage++
            break;

            case 'prev':
                if(this.currentPage != 1){
                    this.currentPage--
                }//end if
            break;
        }//end swithc
    }//end if

    this.apollo
    .watchQuery({
        fetchPolicy: 'network-only',
        query: NEWS_LIST,
        variables: {
            "page": this.currentPage,
            "audience": "ALL",
            "status": "ALL"
        }
    }).valueChanges.subscribe({
      next: (res: any) => {
        if(action != ''){
            if(res.data['news']?.length != 0){
                this.NEList = [];
                this.NEList = res.data['news'];
                this.currentSelectedPageList = this.NEList;
            }else{
                this.currentPage = fromPage;
            }
        }else{
            this.NEList = [];
            this.NEList = res.data['news'];
            this.currentSelectedPageList = this.NEList;
        }
      },
      error: (error) => {
        if (error.message === 'Unauthorized' || error?.networkError?.status === 403) {
            this.authStore.logout().subscribe(() => {
                this.router.navigate(['/admin/login']);
            });
        }
      }
    });
  }//end fn

  nextPrev(action: string){
    switch(action){
        case 'next':
            this.fetchNews('next');
        break;

        case 'prev':
            this.fetchNews('prev');
        break;
    }//end swithc
  }//end fn

  searchData(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    this.searchKeyword = inputElement.value;

    if (this.searchKeyword.trim() === '') {
        console.log('Input is empty');
        this.currentSelectedPageList = this.NEList;
    } else {
        this.currentSelectedPageList = this.NEList.filter(object => {
            // Helper function to recursively search through nested objects
            const searchInObject = (obj: any): boolean => {
                for (const key in obj) {
                    const value = obj[key];

                    // Skip if null or undefined
                    if (value == null) continue;

                    // If value is an object or array, search recursively
                    if (typeof value === 'object') {
                        if (searchInObject(value)) return true;
                    }
                    // Check if the value includes the search term
                    else if (value.toString().toLowerCase().includes(this.searchKeyword.toLowerCase())) {
                        return true;
                    }
                }
                return false;
            };

            return searchInObject(object);
        });
    }
  }//end nfn

  viewDetails(details: NewsItem){
    this.showDetails = true;
    this.detailViewed = details;

    // var cityData = this.locationData.cities.filter((x) => x.citymunDesc == details.city);
    // var provinceData = this.locationData.provinces.filter((x) => x.provDesc == details.province);

    // if(cityData.length != 0){
    //     this.selectedCity = cityData[0];
    // }//emd

    // if(provinceData.length != 0){
    //     this.selectedProvince = provinceData[0];
    // }//emd
  }//end fn

  returnToList(){
      this.showDetails = false;
      this.detailViewed = {};

      this.currentPage = 1;
      this.currentSelectedPageList = this.NEList;
  }//end fn

  showCreateAdForm(modal: TemplateRef<any>){
    this.modalService.open(modal,{ size: 'lg',  backdrop: 'static', keyboard: false });
  }//end fn

  onFileSelected(event: any): void {
    const file: File = event.target.files[0];
    if (file) {
      const allowedTypes = ['image/png', 'image/jpeg'];
      if (!allowedTypes.includes(file.type)) {
        alert('Please select a PNG or JPG file only.');
        event.target.value = '';
        this.imageSrc = undefined;
        this.NEPhoto = null;
        return;
      }

      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.imageSrc = e.target.result;
      };
      reader.readAsDataURL(file);
      this.NEPhoto = file;
    }//end
  }//end fn

  // onSelectProvince(event: any) {
  //   const selectedIndex = event.target.selectedIndex;
  //   const provcode = event.target.options[selectedIndex].getAttribute('data-provcode');

  //   this.filteredCities = this.locationData.cities.filter((x) => x.provCode == provcode);
  // }

  createNE(status: string, confirmModal: TemplateRef <any>){
    if(status == 'draft'){
      this.NEFormNew['status'] = status;
    }else{
      if(this.newPublishToggle){
        this.NEFormNew['status'] = 'published';
      }else{
        this.NEFormNew['status'] = 'unpublished';
      }//end fn
    }//end if

    var errors: number = 0;
    Object.keys(this.NEFormNew).forEach((x) => {
      if(x != 'photo'){
        if(this.NEFormNew[x] == ''){
          console.log(x + ' is empty');
          errors ++;
        }//end if
      }//end if
    });

    if(errors != 0){
      alert('Please enter all required fields');
    }else{
      this.modalService.open(confirmModal, { size: 'md',  backdrop: 'static', keyboard: false });
    }//end if
  }//end fn

  proceedCreateNews(){
    const formData:any = new FormData();
    if (this.NEPhoto) {
      formData.append('file', this.NEPhoto, this.NEPhoto.name);
    }

    this.dasher.uploadPhoto(formData, 'news_photo').subscribe((res: any) => {
      this.NEFormNew['photo'] = res.photo;
      this.apollo.mutate({
          mutation: CREATE_NEWS_MUTATION,
          variables: {
            createNewsInput: this.NEFormNew
          }
      }).subscribe({
          next: ({ data }: any) => {
            if(data['createNews']?.length != 0){
              this.currentPage = 1;
              this.NEList = [data['createNews'], ...this.NEList];
              this.maxPages = this.localservice.getTotalPages(this.NEList, this.pageSize);
              this.NEPages = Array.from({ length: this.maxPages}, (_, i) => i + 1);
              this.currentSelectedPageList = this.localservice.paginateData(this.NEList, this.currentPage, this.pageSize)

              if(this.maxPages == 1){
                  this.disableActionBtns.next = true;
                  this.disableActionBtns.prev = true;
              }else{
                  this.disableActionBtns.next = false;
                  this.disableActionBtns.prev = true;
              }//end if

              this.modalService.dismissAll();
              Object.keys(this.NEFormNew).forEach((x) => {
                this.NEFormNew[x] = '';
              });

              this.imageSrc = null;
              this.NEPhoto = null;
              this.showSuccessModal('News / Event successfully created');
            }
          },
          error: (error) => {
              if (error.message === 'Unauthorized' || error?.networkError?.status === 403) {
                  this.authStore.logout().subscribe(() => {
                      this.router.navigate(['/admin/login']);
                  });
              }
          }
      });
    });
  }//end fn

  closeAllModals(){
    this.modalService.dismissAll();
  }//end fn

  showSuccessModal(message: string){
    this.successMessage = message;
    this.modalService.open(this.successModalRef, { size: 'md', backdrop: 'static', keyboard: false });
  }//end fn

  enableEditForm(){
    this.enableEdit = true;
  }//end fn

  disableEditForm(){
    this.enableEdit = false;
  }//end fn

  openPublishModal(modal: TemplateRef<any>, status: string){
    this.pendingPublishStatus = status;
    this.modalService.open(modal, { size: 'md', backdrop: 'static', keyboard: false });
  }//end fn

  publishThisNews(){
    this.modalService.dismissAll();
    const newStatus = this.pendingPublishStatus;
    const updateInput = {
      audience: this.detailViewed['audience'],
      type: this.detailViewed['type'],
      title: this.detailViewed['title'],
      subTitle: this.detailViewed['subTitle'],
      description: this.detailViewed['description'],
      photo: this.detailViewed['photo'],
      link: this.detailViewed['link'],
      status: newStatus,
    };
    this.apollo.mutate({
        mutation: UPDATE_NEWS_MUTATION,
        variables: {
            newsId: this.detailViewed['newsId'],
            updateNewsInput: updateInput
        }
    }).subscribe({
        next: ({ data }: any) => {
            if(data['updateNews']){
                this.detailViewed = { ...this.detailViewed, status: newStatus };
                this.NEList = this.NEList.map((ne: any) =>
                    ne.newsId === this.detailViewed['newsId'] ? { ...ne, status: newStatus } : ne
                );
                this.currentSelectedPageList = [...this.NEList];
                this.showSuccessModal('News / Event ' + newStatus + ' successfully');
            }
        },
        error: (error) => {
            if (error.message === 'Unauthorized' || error?.networkError?.status === 403) {
                this.authStore.logout().subscribe(() => {
                    this.router.navigate(['/admin/login']);
                });
            }
        }
    });
  }//end fn

  updateThisDetails(){
    const updateInput: Record<string, any> = {
      audience: this.detailViewed['audience'],
      type: this.detailViewed['type'],
      title: this.detailViewed['title'],
      subTitle: this.detailViewed['subTitle'],
      description: this.detailViewed['description'],
      photo: this.detailViewed['photo'],
      link: this.detailViewed['link'],
      status: this.detailViewed['status'],
    };

    const formData:any = new FormData();
    if (this.NEPhoto) {
        formData.append('file', this.NEPhoto, this.NEPhoto.name);
        this.dasher.uploadPhoto(formData, 'news_photo').subscribe((res: any) => {
            updateInput['photo'] = res.photo;
            this.submitUpdateNews(updateInput);
        });
    }else{
        this.submitUpdateNews(updateInput);
    }//end if
  }//end fn

  submitUpdateNews(updateInput: Record<string, any>){
    this.apollo.mutate({
        mutation: UPDATE_NEWS_MUTATION,
        variables: {
            newsId: this.detailViewed['newsId'],
            updateNewsInput: updateInput
        }
    }).subscribe({
        next: ({ data }: any) => {
            if(data['updateNews']){
                this.disableEditForm();
                this.NEPhoto = null;
                this.showSuccessModal('News / Event updated successfully');
            }
        },
        error: (error) => {
            if (error.message === 'Unauthorized' || error?.networkError?.status === 403) {
                this.authStore.logout().subscribe(() => {
                    this.router.navigate(['/admin/login']);
                });
            }
        }
    });
  }//end fn

  // populateLocationDropdowns(){
  //   this.dasher.tryFetchLocations().subscribe((res: any) => {
  //       if(res.length != 0){
  //           res.forEach((location_instance : any) => {
  //               this.locationData.provinces.push(location_instance['province']);
  //               location_instance['cities'].forEach((city_instance: any) => {
  //                   this.locationData.cities.push(city_instance);
  //               });

  //               this.filteredCities = this.locationData.cities;
  //           });
  //       }//end if
  //   });
  // }//end fn

  viewLargerModal(modalLarger: TemplateRef<any>){
    this.modalService.open(modalLarger, {fullscreen:true, size: 'xl',  backdrop: 'static'});
  }//endd fn
}
